import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Input, Output, Component } from '@angular/core';
import { SizeToIconSizePipe } from '@engineering11/ui-lib/e11-ui-config';
import { trigger, state, transition, style, animate } from '@angular/animations';

class E11ShowHideControllerComponent {
    constructor() {
        /**
         * The text to display when the content is hidden.
         */
        this.showText = 'Show';
        /**
         * The text to display when the content is shown.
         */
        this.hideText = 'Hide';
        /**
         * A boolean indicating whether the content is currently collapsed.
         */
        this.isCollapsed = true;
        /**
         * Emits change in collapsed state of the content.
         */
        this.toggle = new EventEmitter();
        /** Size of the icon */
        this.iconSize = 'sm';
    }
    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        this.toggle.emit(this.isCollapsed);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ShowHideControllerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11ShowHideControllerComponent, isStandalone: true, selector: "e11-show-hide-controller", inputs: { showText: "showText", hideText: "hideText", isCollapsed: "isCollapsed", containerClass: "containerClass", iconSize: "iconSize" }, outputs: { toggle: "toggle" }, ngImport: i0, template: `
    <div class="e11-flex e11-items-center e11-cursor-pointer {{ containerClass }}" (click)="toggleCollapse()">
      <span class="e11-mr-1">{{ isCollapsed ? showText : hideText }}</span>
      <span
        class="material-icons-outlined e11-ease-in-out e11-transition-all e11-transform e11-delay-75 {{ iconSize | sizeToIconSize }}"
        [ngClass]="{ 'e11-rotate-180 ': !isCollapsed }"
      >
        expand_circle_down
      </span>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: SizeToIconSizePipe, name: "sizeToIconSize" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ShowHideControllerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-show-hide-controller',
                    standalone: true,
                    imports: [CommonModule, SizeToIconSizePipe],
                    template: `
    <div class="e11-flex e11-items-center e11-cursor-pointer {{ containerClass }}" (click)="toggleCollapse()">
      <span class="e11-mr-1">{{ isCollapsed ? showText : hideText }}</span>
      <span
        class="material-icons-outlined e11-ease-in-out e11-transition-all e11-transform e11-delay-75 {{ iconSize | sizeToIconSize }}"
        [ngClass]="{ 'e11-rotate-180 ': !isCollapsed }"
      >
        expand_circle_down
      </span>
    </div>
  `,
                }]
        }], propDecorators: { showText: [{
                type: Input
            }], hideText: [{
                type: Input
            }], isCollapsed: [{
                type: Input,
                args: [{ required: true }]
            }], toggle: [{
                type: Output
            }], containerClass: [{
                type: Input
            }], iconSize: [{
                type: Input
            }] } });

/**
 * Wraps around the content that you want to show or hide.
 * It includes animations to smoothly transition between the shown and hidden states.
 */
class E11ShowHideWrapperComponent {
    constructor() {
        /**
         * A boolean indicating whether the content is currently collapsed.
         */
        this.isCollapsed = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ShowHideWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11ShowHideWrapperComponent, isStandalone: true, selector: "e11-show-hide-wrapper", inputs: { isCollapsed: "isCollapsed" }, ngImport: i0, template: `
    <div [@collapseAnimation]="isCollapsed ? 'collapsed' : 'expanded'">
      <ng-content></ng-content>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }], animations: [
            trigger('collapseAnimation', [
                state('collapsed', style({
                    height: '0',
                    opacity: '0',
                    overflow: 'hidden',
                })),
                state('expanded', style({
                    height: '*',
                    opacity: '1',
                })),
                transition('collapsed <=> expanded', animate('300ms ease-in-out')),
            ]),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ShowHideWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-show-hide-wrapper',
                    standalone: true,
                    imports: [CommonModule],
                    template: `
    <div [@collapseAnimation]="isCollapsed ? 'collapsed' : 'expanded'">
      <ng-content></ng-content>
    </div>
  `,
                    animations: [
                        trigger('collapseAnimation', [
                            state('collapsed', style({
                                height: '0',
                                opacity: '0',
                                overflow: 'hidden',
                            })),
                            state('expanded', style({
                                height: '*',
                                opacity: '1',
                            })),
                            transition('collapsed <=> expanded', animate('300ms ease-in-out')),
                        ]),
                    ],
                }]
        }], propDecorators: { isCollapsed: [{
                type: Input,
                args: [{ required: true }]
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { E11ShowHideControllerComponent, E11ShowHideWrapperComponent };
